import { React, useEffect, useState } from "react";
import { Drawer, Select, Form } from "antd";
import "./LocationFilter.css";
import FilterSkill from "./skill.Filter";
import { fetchKeySearchSkills } from "../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";

const SkillFilter = ({
	setskillObj,
	skillObj,
	setcheck,
	check=[],
	setFilter,
	addQuery,
	checkSkillId,
	setCheckSkillId,
	emptySkillInput,
	setEmptySkillInput,
	searchLocationFilter,
	countCheck,
}) => {
	const dispatch = useDispatch();
	const [visible, setVisible] = useState(false);
	const [valueCheck, setValueCheck] = useState(check?.map((item) => item.name));
	const [valueCheckId, setValueCheckId] = useState(
		check.map((item) => item.id),
	);
	const [isSelectVisible, setIsSelectVisible] = useState(false);
	useEffect(() => {
		setValueCheck(check.map((item) => item.name));
		setValueCheckId(check.map((item) => item.id));
	}, [check]);
	const showDrawer = () => {
		setVisible(true);
		setIsSelectVisible(false);
	};
	const onClose = () => {
		setVisible(false);
		setIsSelectVisible(false);
	};
	const handleCountryChange = (flag) => {
		if (flag) {
			if (emptySkillInput === "") {
				setEmptySkillInput();
			}
		}
		if (!flag) {
			setEmptySkillInput("");
		}
		setVisible(flag);
	};

	const containerStyle = {
		position: "relative",
		height: "100vh !important",
		overflow: "hidden",
	};

	useEffect(() => {
		if (check.length === 0 && !visible) {
			const params = {
				body: searchLocationFilter,
			};
			dispatch(fetchKeySearchSkills(params));
		} else if (check.length > 0 && !visible) {
			searchLocationFilter.obj["skill"] = valueCheckId;
			const params = {
				body: searchLocationFilter,
			};
			dispatch(fetchKeySearchSkills(params));
		}
	}, [visible]);

	const handleDeselect = (deselectedValue) => {
		const updatedValues = check.filter(
			(value) => value.name !== deselectedValue,
		);
		setcheck(updatedValues);
		setValueCheck(updatedValues);

		const deselectedIndex = check.findIndex(
			(value) => value.name == deselectedValue,
		);
		setCheckSkillId(
			checkSkillId.filter((val, index) => index !== deselectedIndex),
		);
	};

	return (
		<div className="search-location-filter-mobile">
			<Drawer
				className="location-drawer"
				onClose={onClose}
				visible={visible}
				closable={true}
				placement={"top"}
				afterOpenChange={(e) => {
					handleCountryChange(e);
				}}
				contentWrapperStyle={containerStyle}
				title={"Select Skills"}
			>
				<FilterSkill
					setskillObj={setskillObj}
					skillObj={skillObj}
					setcheck={setcheck}
					check={check}
					setFilter={setFilter}
					addQuery={addQuery}
					checkSkillId={checkSkillId}
					setCheckSkillId={setCheckSkillId}
					emptySkillInput={emptySkillInput}
					setEmptySkillInput={setEmptySkillInput}
					searchLocationFilter={searchLocationFilter}
					countCheck={countCheck}
				/>
			</Drawer>

			<Form>
				<Form.Item>
					<Select
						value={valueCheck}
						placeholder="Search skills"
						className="input"
						mode="multiple"
						bordered={false}
						onDeselect={handleDeselect}
						onClick={showDrawer}
						showSearch
						listHeight={160}
						open={isSelectVisible}
					></Select>
				</Form.Item>
			</Form>
		</div>
	);
};

export default SkillFilter;
